import { css } from '@emotion/react'

import { useTranslation } from 'next-i18next'
import html from 'html-react-parser'

import { fade } from '@/styles/global'
import { mediaUp, mediaDown } from '@/styles/media'
import { Text2 } from '@/styles/typography'
import Title from '@/components/common/Title'
import ButtonScroll from '@/components/common/ButtonScroll'
import HeroWrapperWithBackground from '@/components/common/HeroWrapperWithBackground'
import { imageBackgroundHero } from '@/styles/mixins'

function Hero() {
  const { t } = useTranslation('landing')

  const content = (
    <>
      <div css={logosWrapper}>
        <img
          src={
            'https://cdn.naviparking.com/digital_parking/img/saudiExpo-logos.webp'
          }
        />
      </div>
      <Title
        text={t('saudiExpo.hero.title')}
        primary
        css={titleWrapper}
        animated
      />
      <div css={animationWrapper}>
        <Text2 css={lead}>{html(t('saudiExpo.hero.lead'))}</Text2>
        <div css={buttonWrapper}>
          <ButtonScroll anchor="touch-section" text={t('button.inTouch')} />
        </div>
      </div>
    </>
  )

  const images = (
    <>
      <div css={[imageBackground, imageBackgroundDesktop]}>
        <img
          src={
            'https://cdn.naviparking.com/digital_parking/img/bg_saudiExpo.webp'
          }
        />
      </div>
      <div css={[imageBackground, imageBackgroundMobile]}>
        <img
          src={
            'https://cdn.naviparking.com/digital_parking/img/bg_saudiExpo-mobile.webp'
          }
        />
      </div>
    </>
  )

  return <HeroWrapperWithBackground content={content} images={images} />
}

const buttonWrapper = css`
  display: flex;
  margin-top: 18px;
  margin-bottom: 110px;

  ${mediaUp('md')} {
    margin-bottom: 0;
  }

  ${mediaUp('lg')} {
    margin-top: 40px;
  }
`

const imageBackground = css`
  ${imageBackgroundHero};

  img {
    width: 100%;
    height: 100%;
  }
`

const imageBackgroundMobile = css`
  ${mediaUp('md')} {
    display: none;
  }
`

const imageBackgroundDesktop = css`
  ${mediaDown('md')} {
    display: none;
  }
`

const logosWrapper = css`
  position: relative;
  width: 200px;
  height: 25px;
  margin-bottom: 18px;

  ${mediaUp('lg')} {
    width: 366px;
    height: 40px;
    margin-bottom: 30px;
  }

  img {
    object-fit: contain;
    width: -webkit-fill-available;
  }
`

const titleWrapper = css`
  max-width: 380px;

  ${mediaDown('md')} {
    word-wrap: break-word;
  }

  ${mediaUp('lg')} {
    max-width: none;
  }
`

const lead = css`
  margin-top: 14px;

  ${mediaUp('lg')} {
    margin-top: 30px;
  }
`

const animationWrapper = css`
  animation: ${fade} 1s both;
  animation-delay: 0.75s;
`

export default Hero
